





























































































import { Vue, Component } from 'vue-property-decorator';

import APIService from '@/api';

import { Surface, Typography } from '@/components/atoms';
import Checkpoint from '@/components/molecules/Checkpoint/Checkpoint.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import ExternalLinkIcon from '@/components/icons/ExternalLink.vue';
import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import LogoutIcon from '@/components/icons/Logout.vue';

import eventBus from '@/utils/eventBus';
import isMobile from '@/utils/mobile-check';
import getFirstName from '@/utils/get-first-name';

@Component({
  components: {
    Surface,
    Typography,
    Checkpoint,
    FilledButton,
    ExternalLinkIcon,
    CloseModalIcon,
    Picture,
    LogoutIcon
  }
})
export default class NewOnboardingSuccessModal extends Vue {
  get tPrefix() {
    return 'onboarding.success';
  }

  get managerName() {
    if (this.businessInfo && this.businessInfo.manager) {
      return getFirstName(this.businessInfo.manager.fullname) || 'Owner';
    }

    return null;
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get businessRegistrations() {
    return this.$store.getters['registration/getBusinessRegistration'];
  }

  get completedRegistrations() {
    return this.businessRegistrations
      .filter(
        (registration: any) =>
          registration.businessSignupSteps[0].status === 'seen'
      )
      .sort((next: any, prev: any) => {
        if (next.order < prev.order) {
          return -1;
        }

        if (next.order > prev.order) {
          return 1;
        }

        return 0;
      })
      .map(({ title }: any) => title);
  }

  get websiteAddress() {
    const business = this.businessInfo;

    if (!business || !business.website) return '';

    return business.website;
  }

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  get deviceIsMobile() {
    return isMobile();
  }

  async logout() {
    APIService.resetCredentials();
  }

  get getFlags() {
    return this.$store.getters['flags/getFlags'];
  }

  async onClose() {
    this.$router.push('/');
    eventBus.$emit('closeModal');
  }
}
